(function () {
  const STYLE_ID = "ctm-inquiry-form-styles";
  const EMBED_SELECTOR = ".special-work-inquiry shopify-forms-embed";
  const FORM_SELECTOR = 'form[data-testid="form"]';
  let retryCount = 0;
  const MAX_RETRIES = 20;

  const CSS_TEXT = `
    /* Hide empty image slot that causes white space above form */
    [data-sizing="form-wrapper"][role="dialog"] > div:first-child {
      display: none !important;
    }

    /* Reset form container paddings */
    [data-sizing="form-wrapper"][role="dialog"] {
      padding: 0 !important;
      max-width: 100% !important;
      box-shadow: none !important;
    }

    [data-form-root] {
      padding: 0 !important;
    }

    /* 2-column grid on the form */
    ${FORM_SELECTOR} {
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      gap: 40px !important;
      text-align: left !important;
    }

    /* Full-width: shop-lead-capture wrapper (contains shop-lead-capture element) */
    ${FORM_SELECTOR} > div:has(shop-lead-capture),
    /* Full-width: product name and message fields (robust — unaffected by error <output> count shifts) */
    ${FORM_SELECTOR} > [class*="_formFieldContainer_"]:has([id*="product_name"]),
    ${FORM_SELECTOR} > [class*="_formFieldContainer_"]:has(textarea),
    /* Full-width: submit button */
    ${FORM_SELECTOR} > button[type="submit"] {
      grid-column: 1 / -1 !important;
    }

    /* Errors inside field containers (moved there by JS — appear below input) */
    ${FORM_SELECTOR} [class*="_formFieldContainer_"] output[role="alert"] {
      color: #e02229 !important;
      font-size: 13px !important;
      font-family: 'roc-grotesk', sans-serif !important;
      font-weight: 400 !important;
      display: block !important;
      margin-top: 6px !important;
      order: 2 !important;
      padding: 0 !important;
    }

    /* Fallback: errors still direct form children (pre-JS-move) */
    ${FORM_SELECTOR} > output[role="alert"] {
      color: #e02229 !important;
      font-size: 13px !important;
      font-family: 'roc-grotesk', sans-serif !important;
      font-weight: 400 !important;
      display: block !important;
      grid-column: 1 / -1 !important;
      padding: 0 !important;
    }

    /* Field containers: column so static label sits above input */
    ${FORM_SELECTOR} > div:not(:first-child):not(:has(shop-lead-capture)) {
      display: flex !important;
    }

    /* Fallback: target by class name to catch any nth-child counting edge cases */
    ${FORM_SELECTOR} > [class*="_formFieldContainer_"] {
      display: flex !important;
      flex-direction: column !important;
    }

    /* Labels: static positioning (override floating label pattern) */
    ${FORM_SELECTOR} label {
      position: static !important;
      top: auto !important;
      transform: none !important;
      transition: none !important;
      order: -1 !important;
      display: block !important;
      margin-bottom: 8px !important;
      pointer-events: auto !important;
      font-family: 'roc-grotesk', sans-serif !important;
      font-size: 22px !important;
      font-weight: 500 !important;
      color: #000000 !important;
      line-height: normal !important;
      z-index: auto !important;
    }

    /* Bottom border only on all inputs and textarea */
    ${FORM_SELECTOR} input:not([type="hidden"]),
    ${FORM_SELECTOR} textarea {
      box-shadow: none !important;
      border: none !important;
      border-bottom: 1px solid rgba(178, 178, 177, 0.5) !important;
      border-radius: 0 !important;
      background: transparent !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
      padding-top: 8px !important;
      padding-bottom: 8px !important;
      font-family: 'roc-grotesk', sans-serif !important;
      font-size: 18px !important;
    }

    ${FORM_SELECTOR} input:not([type="hidden"]):focus,
    ${FORM_SELECTOR} textarea:focus {
      box-shadow: none !important;
      border-bottom: 2px solid rgba(32, 32, 32, 0.8) !important;
      outline: none !important;
    }

    /* Phone container: flag left, input right on same row; wrap so error falls below */
    ${FORM_SELECTOR} [class*="_formPhoneInputContainer_"] {
      display: flex !important;
      flex-direction: row !important;
      align-items: flex-end !important;
      gap: 12px !important;
      order: 0 !important;
    }

    /* Phone error: full-width wrap onto line below flag+input */
    ${FORM_SELECTOR} [class*="_formPhoneInputContainer_"] > output[role="alert"] {
      flex-basis: 100% !important;
      width: 100% !important;
      color: #e02229 !important;
      font-size: 13px !important;
      font-family: 'roc-grotesk', sans-serif !important;
      font-weight: 400 !important;
      margin-top: 0 !important;
    }

    /* Phone inner field: fill remaining width, label above input */
    ${FORM_SELECTOR} [class*="_formPhoneInputContainer_"] [class*="_formFieldContainer_"] {
      flex: 1 1 auto !important;
      display: flex !important;
      flex-direction: column !important;
      min-width: 0 !important;
    }

    /* Country selector: no shrink, align to bottom */
    ${FORM_SELECTOR} [class*="_formPhoneInputContainer_"] .phone-country-selector {
      flex-shrink: 0 !important;
      align-self: flex-end !important;
    }

    /* Country selector toggle text: auto width, no right margin */
    ${FORM_SELECTOR} [class*="_formPhoneInputContainer_"] [class*="_selectToggleText_"] {
      width: 100% !important;
      margin-right: 10px !important;
    }

    /* Remove white ::before overlay that covers the Message label */
    ${FORM_SELECTOR} [class*="_formFieldContainer_"]:has(textarea)::before {
      background-color: transparent !important;
    }

    /* Message label: force visible above textarea */
    ${FORM_SELECTOR} label[for="custom#message"] {
      display: block !important;
      position: static !important;
      visibility: visible !important;
      opacity: 1 !important;
      color: #000000 !important;
      font-size: 22px !important;
      font-weight: 500 !important;
      order: -1 !important;
    }

    /* Submit button: left-aligned, auto width, orange, arrow suffix */
    ${FORM_SELECTOR} > button[type="submit"] {
      font-family: 'roc-grotesk', sans-serif !important;
      font-size: 32px !important;
      font-weight: 500 !important;
      line-height: 40px !important;
      text-align: left !important;
      justify-self: start !important;
      padding: 0 !important;
      background: transparent !important;
      border: none !important;
      color: #e18131 !important;
      cursor: pointer !important;
      box-shadow: none !important;
      border-radius: 0 !important;
      min-height: auto !important;
      width: auto !important;
      display: inline-flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 16px !important;
    }

    ${FORM_SELECTOR} > button[type="submit"] .ctm-btn-arrow {
      display: inline-flex !important;
      align-items: center !important;
      flex-shrink: 0 !important;
    }

    ${FORM_SELECTOR} > button[type="submit"]:hover {
      opacity: 0.8 !important;
      background: transparent !important;
    }

    /* Success state */
    [data-testid="banner-success"] {
      padding: 0 !important;
      text-align: left !important;
    }

    [data-testid="banner-success"] h2,
    [class*="_formBannerHeading_"] {
      font-family: 'roc-grotesk', sans-serif !important;
      font-size: 48px !important;
      font-weight: 500 !important;
      color: #e18131 !important;
      line-height: 1.1 !important;
      margin: 0 0 16px !important;
    }

    [data-testid="banner-success"] [class*="_textBody_"] p {
      font-family: 'roc-grotesk', sans-serif !important;
      font-size: 18px !important;
      font-weight: 400 !important;
      color: #000000 !important;
      line-height: 1.6 !important;
      margin: 0 !important;
    }

    /* Mobile: single column */
    @media (max-width: 989px) {
      ${FORM_SELECTOR} {
        grid-template-columns: 1fr !important;
      }
      ${FORM_SELECTOR} > div,
      ${FORM_SELECTOR} > button[type="submit"] {
        grid-column: 1 / -1 !important;
      }
    }
  `;

  const ARROW_SVG = `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.3841 5.61557C22.6181 5.84994 22.7496 6.16765 22.7496 6.4989C22.7496 6.83015 22.6181 7.14786 22.3841 7.38223L8.21739 21.5489C7.98043 21.7697 7.66702 21.8899 7.34318 21.8842C7.01935 21.8785 6.71037 21.7473 6.48135 21.5183C6.25233 21.2892 6.12114 20.9803 6.11543 20.6564C6.10972 20.3326 6.22992 20.0192 6.45072 19.7822L20.6174 5.61557C20.8518 5.38148 21.1695 5.25 21.5007 5.25C21.832 5.25 22.1497 5.38148 22.3841 5.61557Z" fill="#E18131"/><path d="M5.25 6.5C5.25 6.16848 5.3817 5.85054 5.61612 5.61612C5.85054 5.3817 6.16848 5.25 6.5 5.25H21.5C21.8315 5.25 22.1495 5.3817 22.3839 5.61612C22.6183 5.85054 22.75 6.16848 22.75 6.5V21.5C22.75 21.8315 22.6183 22.1495 22.3839 22.3839C22.1495 22.6183 21.8315 22.75 21.5 22.75C21.1685 22.75 20.8505 22.6183 20.6161 22.3839C20.3817 22.1495 20.25 21.8315 20.25 21.5V7.75H6.5C6.16848 7.75 5.85054 7.6183 5.61612 7.38388C5.3817 7.14946 5.25 6.83152 5.25 6.5Z" fill="#E18131"/></svg>`;

  function injectArrow(root) {
    const btn = root.querySelector(`${FORM_SELECTOR} > button[type="submit"]`);
    if (!btn || btn.querySelector(".ctm-btn-arrow")) {
      return;
    }
    const span = document.createElement("span");
    span.className = "ctm-btn-arrow";
    span.setAttribute("aria-hidden", "true");
    span.innerHTML = ARROW_SVG;
    btn.appendChild(span);
  }

  function moveErrorsIntoFields(root) {
    const form = root.querySelector(FORM_SELECTOR);
    if (!form) {
      return;
    }
    Array.from(form.children).forEach(function (el) {
      if (el.tagName === "OUTPUT" && el.getAttribute("role") === "alert") {
        const prev = el.previousElementSibling;
        if (prev) {
          prev.appendChild(el);
        }
      }
    });
    const phoneContainer = root.querySelector(
      `${FORM_SELECTOR} [class*="_formPhoneInputContainer_"]`,
    );
    if (phoneContainer) {
      const phoneError = phoneContainer.querySelector(
        ":scope > output[role='alert']",
      );
      const phoneField = phoneContainer.querySelector(
        "[class*='_formFieldContainer_']",
      );
      if (phoneError && phoneField) {
        phoneField.appendChild(phoneError);
      }
    }
  }

  function prefillProductName(root) {
    const productName = new URLSearchParams(window.location.search).get(
      "product",
    );
    if (!productName) {
      return;
    }
    const input = root.querySelector(
      `${FORM_SELECTOR} input[id*="product_name"]`,
    );
    if (!input || input.dataset.ctmPrefilled) {
      return;
    }
    const nativeSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value",
    ).set;
    nativeSetter.call(input, productName);
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dataset.ctmPrefilled = "1";
  }

  function injectIntoRoot(root) {
    if (root.getElementById(STYLE_ID)) {
      return;
    }
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = CSS_TEXT;
    root.appendChild(style);
    injectArrow(root);
  }

  function watchRoot(root) {
    const observer = new MutationObserver(function () {
      injectIntoRoot(root);
      injectArrow(root);
      moveErrorsIntoFields(root);
      prefillProductName(root);
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function attemptInject() {
    const embed = document.querySelector(EMBED_SELECTOR);
    if (!embed || !embed.shadowRoot) {
      return false;
    }
    const root = embed.shadowRoot;
    if (!root.querySelector(FORM_SELECTOR)) {
      return false;
    }
    injectIntoRoot(root);
    prefillProductName(root);
    watchRoot(root);
    return true;
  }

  function scheduleRetry() {
    retryCount++;
    if (retryCount >= MAX_RETRIES) {
      return;
    }
    setTimeout(function () {
      if (!attemptInject()) {
        scheduleRetry();
      }
    }, 300);
  }

  if (!attemptInject()) {
    scheduleRetry();
  }
})();
